import ApiStorage from './ApiStorage';
import ApiAjax from './ApiAjax';

export default class Api {
  static config = {
    host: '',
    agency: '',
    login: '',
    secret: '',
    user: '',
    token: '',
    login_url: '/tourclient/login/',
  };

  constructor(request) {
    return Api.promise(request);
  }

  static async promise(request) {
    try {
      const store = await ApiStorage.get(request.store);
      if (store) return Promise.resolve(store);
      const data = await new ApiAjax(request);
      await ApiStorage.set(request.store, data);
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  static get(url, parameters = {}) {
    return Api.promise({
      url,
      method: 'get',
      ...parameters,
    });
  }

  static post(url, data, parameters = {}) {
    return Api.promise({
      url,
      method: 'post',
      data,
      ...parameters,
    });
  }

  static del(url, parameters = {}) {
    return Api.promise({
      url,
      method: 'delete',
      ...parameters,
    });
  }

  static async remove(key) {
    try {
      await ApiStorage.remove(key);
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  }
}
